import React, { FC, PropsWithChildren, ReactNode } from 'react'

import { MobileHitListLink } from 'components/presentational/HitList/HitListLink/MobileHitListLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { Row, Wrapper, Text } from './HeaderComponent.styled'

export const HeaderComponent: FC<
  {
    settings?: ReactNode
    goBack?: ReactNode
    showMobileHitListLink?: boolean
  } & PropsWithChildren
> = ({
  settings = null,
  children,
  goBack = null,
  showMobileHitListLink = true,
}) => {
  const { authorized, touch } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized }, systemReducer: { touch } }) => ({
      authorized,
      touch,
    })
  )

  const settingsRowElement = settings ? <Row>{settings}</Row> : undefined

  if (authorized && !goBack) {
    return (
      <Wrapper>
        {touch && showMobileHitListLink ? <MobileHitListLink /> : <div />}
        <Text>{children}</Text>
        {settingsRowElement}
      </Wrapper>
    )
  }

  if (goBack) {
    return (
      <Wrapper>
        <Row>{goBack}</Row>
        <Text>{children}</Text>
        {settingsRowElement}
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <div />
      <Text>{children}</Text>
      {settingsRowElement}
    </Wrapper>
  )
}
